module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "validacao-de-minuta",
    attrs: {
      "id": "validacao-de-minuta"
    }
  }, [_c('div', {
    staticClass: "container_medio container_com-fundo container_com-margem u-padding-grande"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-ao-topo"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('div', {
    staticClass: "titulo titulo_grande u-margem-inferior-media"
  }, [_vm._v("\n          Validação de minuta\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "data-situacao u-margem-inferior-media"
  }, [_c('span', [_vm._v("Data da aprovação: ")]), _vm._v(" "), (this.dataDeAprovacao) ? _c('span', [_vm._v(_vm._s(_vm.$tempo.formatarParaPadraoBrasileiro(this.dataDeAprovacao)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_9"
  }, [_c('div', {
    staticClass: "u-nao-imprimir grade__linha grade__linha_alinhar-horizontal-direita"
  }, [_c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media",
    attrs: {
      "type": "button",
      "disabled": _vm.minutaDoCertificadoFoiValidada
    },
    on: {
      "click": _vm.abrirModalDeAprovacao
    }
  }, [_vm._v("\n            Aprovar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-inferior-grande",
    attrs: {
      "type": "button",
      "disabled": _vm.minutaDoCertificadoFoiValidada
    },
    on: {
      "click": _vm.abrirModalDeReprovacao
    }
  }, [_vm._v("\n            Reprovar\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_12"
  }, [_c('div', {
    staticClass: "pdf-container"
  }, [_c('embed', {
    attrs: {
      "src": _vm.pdfUrl,
      "type": "application/pdf",
      "width": "100%",
      "height": "100%"
    }
  })])])]), _vm._v(" "), (_vm.modalDeAprovacaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeAprovacao
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.aprovarMinuta.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Aprovar minuta")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao u-margem-inferior-grande"
  }, [_c('strong', [_vm._v("Tem certeza que deseja aprovar essa minuta?")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeAprovacao
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Confirmar\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modalDeReprovacaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeReprovacao
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.reprovarMinuta.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Reprovar minuta")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Motivo da reprovação")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativaDaReprovacao),
      expression: "justificativaDaReprovacao"
    }],
    staticClass: "input u-margem-inferior-media",
    attrs: {
      "name": "justificativa",
      "id": "justificativa",
      "cols": "30",
      "rows": "8",
      "placeholder": "Descreva aqui o motivo detalhadamente",
      "required": ""
    },
    domProps: {
      "value": (_vm.justificativaDaReprovacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativaDaReprovacao = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeReprovacao
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.justificativaDaReprovacaoEstaPreenchida
    }
  }, [_vm._v("\n            Confirmar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22bb941f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22bb941f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/mcmv-cidades/ValidacaoDeMinuta.vue
// module id = 1095
// module chunks = 1